import { BankerEntity, EMPTY_BANKER_ENTITY } from "domain/entity/Banker/BankerEntity";
import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { BankerRepository } from "domain/repository/Banker/BankerRepo";
import { ExchangeRateRepository } from "domain/repository/ExchangeRate/ExchangeRateRepo";
import { createBankerValidationSchema } from "presentation/constant/Banker/BankerValidationSchema";
import { Validation } from "presentation/constant/Validation";
import { BankerModel } from "presentation/model/Banker/BankerModel";
import { Dispatch, SetStateAction } from "react";
import { IFieldValue } from "veronica-ui-component/dist/component/core";
import BaseViewModel from "../BaseViewModel";

interface BankerVMProps extends BaseViewModel {
    dispatch: [
        Dispatch<SetStateAction<BankerModel>> | ((value: SetStateAction<BankerModel>) => void),
    ],
    repo: BankerRepository,
    exchangeRateRepo: ExchangeRateRepository,
}

export const BankerVM = ({ dispatch, repo, exchangeRateRepo }: BankerVMProps) => {
    const [bankerMainDispatch] = dispatch;

    const loadDropdownOption = async () => {

        await exchangeRateRepo.getAllCurrencies().then(
            currencies => {
                let currencyDropdownOptions = currencies?.map((currency) => ({
                    dropdownLabel: currency.currencyCode,
                    tagLabel: currency.currencyCode,
                    value: currency.currencyCode,
                })) ?? []

                bankerMainDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        currencyCodeDropdownOptions: currencyDropdownOptions,
                    }
                }))
            }
        )
    }
    const onSearch = async () => {
        bankerMainDispatch(prevState => {
            return {
                ...prevState,
                bankerList: []
            }
        });
        await repo.getEntities().then((data) => {
            bankerMainDispatch(prevState => {
                return {
                    ...prevState,
                    bankerList: data,
                    isShowEditPanel: false,
                    isAdd: false,
                    isEdit: false,
                }
            });
        });
    }

    const onCloseEidtPanel = async () => {
        bankerMainDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: { ...EMPTY_BANKER_ENTITY },
                isShowEditPanel: false,
                isAdd: false,
                isEdit: false,
                masterState: {
                    ...prevState.masterState,
                    allFormState: {}
                }
            }
        });
    }

    const onSave = async (row: BankerEntity) => {
        const valResult = await Validation(createBankerValidationSchema).ValidateFormOnly(row);
        let validatedResult: { [x: string]: string } = {};
        if (valResult) {
            validatedResult = { ...valResult };

            bankerMainDispatch(prevState => {
                return {
                    ...prevState,
                    masterState: {
                        ...prevState.masterState,
                        allFormState: {
                            ...validatedResult
                        },
                    }
                }
            });

            const res: ResponseEntity = {
                code: "",
                success: false,
                msg: null,
                data: null
            }

            return res;
        }
        return await repo.onSave(row);
    }

    const onSaveClicked = () => {
        bankerMainDispatch(prevState => {
            return {
                ...prevState,
                masterState: {
                    ...prevState.masterState,
                    isSaveClicked: true,
                    allFormState: {},
                }
            }
        })
    }

    const onFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        bankerMainDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: {
                    ...prevState.currentEditRow,
                    [fieldKey]: val,
                },
                masterState: {
                    ...prevState.masterState,
                    allFormState: {
                        ...prevState.masterState.allFormState,
                        [fieldKey]: ''
                    },
                }
            }
        })
    }

    const onCheckboxChange = (checked: boolean, fieldName: string) => {
        bankerMainDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: {
                    ...prevState.currentEditRow,
                    [fieldName]: checked ? "Y" : "N",
                },
            }
        })
    }

    const onResetClick = async (isAdd: boolean) => {
        bankerMainDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: isAdd ? { ...EMPTY_BANKER_ENTITY } : prevState.currentRow,
            }
        })
    }

    const onEditClick = async () => {
        bankerMainDispatch(prevState => {
            return {
                ...prevState,
                isEdit: true,
            }
        })
    }

    const onRowDoubleClick = async (entity: BankerEntity) => {
        bankerMainDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: entity,
                currentRow: entity,
                isShowEditPanel: true,
            }
        })
    }

    const onAddClick = async () => {
        bankerMainDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: {
                    ...EMPTY_BANKER_ENTITY,
                    bankAcCurrency: prevState.dynamicOptions.currencyCodeDropdownOptions.length > 0 ? prevState.dynamicOptions.currencyCodeDropdownOptions?.sort((a, b) => a?.dropdownLabel!.localeCompare(b?.dropdownLabel!))?.[0]?.value : null
                },
                isAdd: true,
                isShowEditPanel: true,
            }
        })
    }

    const updateSelectedRows = async (rows: BankerEntity[]) => {

        bankerMainDispatch(prevState => {
            return {
                ...prevState,
                selectedRows: rows,
            }
        })
    }

    return {
        onSave: onSave,
        onSearch: onSearch,
        updateSelectedRows: updateSelectedRows,
        onAddClick: onAddClick,
        onRowDoubleClick: onRowDoubleClick,
        onEditClick: onEditClick,
        onResetClick: onResetClick,
        onCheckboxChange: onCheckboxChange,
        onFieldChange: onFieldChange,
        onCloseEidtPanel: onCloseEidtPanel,
        loadDropdownOption: loadDropdownOption,
        onSaveClicked: onSaveClicked,

    }
}